import styled from 'styled-components';

export const TabContainer = styled.div`
    background-color: ${(props) => props.theme.app.backgroundColorBase};
    padding: 20px;
`;
